import clsx from 'clsx';
import { HTMLProps, ReactNode } from 'react';

import styles from './CardTable.module.scss';

const Column = ({
  header = false,
  center = false,
  children,
  className,
  ...props
}: {
  header?: boolean;
  center?: boolean;
  children: ReactNode | ReactNode[];
  className?: string;
} & HTMLProps<HTMLTableCellElement>) => {
  const Element = header ? 'th' : 'td';
  return (
    <Element
      className={clsx(
        header ? styles['card-table-header'] : styles['card-table-column'],
        center && styles['center'],
        className,
      )}
      {...props}
    >
      {children}
    </Element>
  );
};

const Row = ({
  bold = false,
  center = false,
  children,
  className,
  ...props
}: {
  bold?: boolean;
  center?: boolean;
  children: ReactNode | ReactNode[];
  className?: string;
} & HTMLProps<HTMLTableRowElement>) => {
  return (
    <tr
      className={clsx(styles['card-table-row'], bold && styles['bold'], center && styles['center'], className)}
      {...props}
    >
      {children}
    </tr>
  );
};

export const CardTable = ({
  headers,
  children,
  className,
  ...props
}: {
  headers: string[];
  children: ReactNode | ReactNode[];
  className?: string;
}) => {
  return (
    <table className={clsx(styles['card-table'], className)} {...props}>
      <thead>
        <Row>
          {headers.map((val, i) => (
            <Column header key={i + val}>
              {val !== '' ? val : <>&nbsp;</>}
            </Column>
          ))}
        </Row>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};

CardTable.Row = Row;
CardTable.Col = Column;
